export default function openLeftMenu() {
  document.getElementById("boMenu").classList.add("bo-menu-overlay");
  document.getElementById("leftNav").style.cssText =
    "position: fixed; width: 24.7rem; height: 100%; top: 0; z-index: 7; display : flex";
  document.getElementById("body").style = "overflow: hidden";
}